import { API_URL } from "./config";
import axios from "axios";

const RULESETS_URL = `${API_URL}/rulesets`;

export interface RulesetModel {
  id: string;
  name: string;
  stage: string;
  category: string;
}

export interface RulesetExtItem extends RulesetModel {
  displayName?: string;
}

export const listRulesets = async (
  page: number = 1,
  pageSize: number = 5
): Promise<any> => {
  const response = await axios
    .get(RULESETS_URL, {
      params: {
        page: page.toString(),
        page_size: pageSize.toString(),
      },
    })
    .catch((error) => {
      console.error("Error list projects", error);
      throw error;
    });

  return response.data;
};
